import React, { useState } from 'react';
import { domain } from '../../../../Urls/Services/Api_urls';
import Swal from 'sweetalert2';
import { EditPencil, WarningTriangleOutline } from 'iconoir-react';
import { renderToStaticMarkup } from 'react-dom/server';
import {
    LETRAS_CASA,
    NUMEROS_CASA,
    NUMEROS_APTO,
    PISOS,
    PISOS_APTO,
    armarComplemento,
    complementoCompleto,
    separarComplemento,
} from '../../../CoberturaFTTH/complemento';

export const EditSol = (props) => {
    const { planes, tableMeta } = props;
    const tipoCliente = [{ id: 45, name: 'Residencial' }, { id: 41, name: 'VIP' }, { id: 42, name: 'Corporativo' }, { id: 43, name: 'Pymes' }, { id: 44, name: 'Oficial' }, { id: 46, name: 'SOHO' }, { id: 47, name: 'comunidad RUAV' }, { id: 48, name: 'convenio-EMCALI-ALCALDIA' },]
    const [price_plan, setPrice] = useState(tableMeta.price_plan);
    const [id_plan, setId_plan] = useState(tableMeta.id_plan);
    const [id_plan_open, setId_plan_open] = useState(tableMeta.id_plan_open);
    const [plan_type, setPlan_type] = useState(tableMeta.plan_type);
    const [plan, setPlan] = useState(tableMeta.plan);

    const token = window.sessionStorage.getItem("token");
    const groups = window.sessionStorage.getItem("groups");
    const isUser = groups === "Usuario" || groups === "Usuario_Universidades";

    const campoArchivo = (inputId, ruta) => {
        const nombre = ruta ? decodeURIComponent(ruta.split("/").pop()) : "";
        return `
        <style>.btn-archivo{background-color:#e9ecef;color:#212529;border:1px solid #ced4da;border-radius:.375rem 0 0 .375rem;}.btn-archivo:hover:not(:disabled){background-color:#d3d9df;color:#212529;}.btn-archivo:focus-visible,.btn-archivo:active{background-color:#e9ecef;color:#212529;border-color:#ced4da;}</style>
        <input id="${inputId}" type="file" style="display:none">
        <div class="input-group mb-4">
            <button type="button" class="btn btn-archivo" id="${inputId}-cargar">Cargar archivo</button>
            <div class="form-control" id="${inputId}-nombre" style="text-align:left; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                ${nombre ? `<a target="_blank" href="${domain}${ruta}">${nombre}</a>` : `<span style="color:#6c757d">Seleccionar archivo</span>`}
            </div>
        </div>`;
    };

    const identityNotice = isUser ? "" : `
                                    <div style="display: flex; align-items: center; gap: 0.35rem; flex-wrap: wrap; font-size: 0.9rem; text-align: left; margin-bottom: 0.4rem;">
                                        ${renderToStaticMarkup(<WarningTriangleOutline width={16} height={16} style={{ color: "#d97706", flexShrink: 0 }} />)}
                                        <strong>Verifica la identidad del cliente.</strong>
                                        <a href="https://www.procuraduria.gov.co/Pages/consulta-de-antecedentes.aspx" target="_blank" rel="noopener noreferrer">Consulta de antecedentes</a>
                                    </div>`;

    const getTipoClienteId = (name) => {
        const cliente = tipoCliente.find(tipo => tipo.name === name);
        return cliente ? cliente.id : '';
    };

    const { base: addressBase, ...addressComp } = separarComplemento(tableMeta.address);
    const canEditAddress = groups === "Backoffice" || groups === "facilitador_comercial";

    const selectComplemento = (id, etiqueta, opciones, valor) => `
        <div class="col">
            <select class="select" id="${id}" style="width: 100%; height: 2rem;" ${canEditAddress ? "" : "disabled"}>
                <option value="">${etiqueta}</option>
                ${opciones.map(o => `<option value="${o}" ${o === valor ? "selected" : ""}>${o}</option>`).join('')}
            </select>
        </div>`;

    // Campos que dependen del tipo: Casa (letra + No.), Piso (No. piso), Apartamento (piso apto + No. apto).
    const camposComplemento = (tipo, v = {}) => {
        if (tipo === "Casa") {
            return selectComplemento("swal-comp-letra", "Letra", LETRAS_CASA, v.letra)
                + selectComplemento("swal-comp-num", "No.", NUMEROS_CASA, v.num);
        }
        if (tipo === "Piso") {
            return selectComplemento("swal-comp-num", "No. Piso", PISOS, v.num);
        }
        if (tipo === "Apartamento") {
            return selectComplemento("swal-comp-pisoapto", "Piso apto", PISOS_APTO, v.pisoApto)
                + selectComplemento("swal-comp-num", "No. apto", NUMEROS_APTO, v.num);
        }
        return "";
    };

    const leerComplemento = () => {
        const valor = (id) => document.getElementById(id)?.value || "";
        return {
            tipo: valor("swal-comp-tipo"),
            letra: valor("swal-comp-letra"),
            num: valor("swal-comp-num"),
            pisoApto: valor("swal-comp-pisoapto"),
        };
    };

    const allowedStatus = new Set(["Orden creada"]);
    const allowedGroups2 = new Set(["vendedor_PAP", "Usuario"]);

    const updatePrice = (planValue, estratoValue) => {
        const data = JSON.parse(decodeURIComponent(planValue));

        const { nombre_plan, codigo_open, id__planes, tipoplan, json_valor, descuento_valor } = data;

        const newPrice = descuento_valor ? descuento_valor[estratoValue] : json_valor.residencial[estratoValue];
        const price = Math.trunc(newPrice) !== undefined ? Math.trunc(newPrice) : 'N/A';
        console.log(price);
        
        setPrice(Math.trunc(price));
        setId_plan(id__planes);
        setId_plan_open(codigo_open);
        setPlan_type(tipoplan);
        setPlan(nombre_plan);

        document.getElementById('swal-price-input').value = price;
        document.getElementById('swal-idplan-input').value = id__planes;
        document.getElementById('swal-idopen-input').value = codigo_open;
        document.getElementById('swal-typeplan-input').value = tipoplan;
        document.getElementById('swal-Plan-input').value = nombre_plan;
       

    };

    const handleSubmit = () => {
        const headers = new Headers({
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        });

        fetch(`${domain}/portal/${tableMeta.id}/`, { method: "GET", headers })
            .then(response => response.json())
            .then(result => Swal.fire({
                title: "Editar Solicitud",
                html: `
                    <form>
                        <div class="m-3">
                            <div class="row mb-3">
                                <div class="col-6">
                                    <label for="NameLabelUpdate" class="labelFount">Nombre</label>
                                    <input type="text" id="swal-name-input" class="form-control" placeholder="Nombre" value="${tableMeta.name}">
                                </div>
                                <div class="col-6">
                                    <label for="NameLabelUpdate" class="labelFount">Apellido</label>
                                    <input type="text" id="swal-last_name-input" class="form-control" placeholder="Apellido" value="${tableMeta.last_name}">
                                </div>
                                <div class="col-6">
                                    <label for="NameLabelUpdate" class="labelFount" style="margin-top: 1rem;">Documento</label>
                                    <input type="text" id="swal-input2" class="form-control" placeholder="DNI Propietario" value="${tableMeta.cc}" style="width: 100%; height: 2.2rem; margin-bottom: 1.5rem;" ${isUser? "disabled" : ""}>
                                    </div>
                                    <div class="col-6">
                                    <label for="NameLabelUpdate" class="labelFount" style="margin-top: 1rem;">Celular</label>
                                    <input type="text" id="swal-input3" class="form-control" placeholder="CEL Propietario" value="${tableMeta.contact_phone}" style="width: 100%; height: 2.2rem; margin-bottom: 1.5rem;">
                                    </div>
                                    ${identityNotice}
                            </div>
                            <div class="mb-4">
                                <label for="swal-address-base" class="labelFount">Dirección Propietario</label>
                                <input type="text" id="swal-address-base" class="form-control" disabled
                                    style="background-color: #e9ecef;"
                                    placeholder="Dirección base" value="${addressBase}">
                            </div>
                            <div class="mb-4">
                                <label class="labelFount">Complemento</label>
                                <select class="select" id="swal-comp-tipo" style="width: 100%; height: 2rem;" ${canEditAddress ? "" : "disabled"}>
                                    <option value="" ${addressComp.tipo === "" ? "selected" : ""}>Ninguno</option>
                                    <option value="Casa" ${addressComp.tipo === "Casa" ? "selected" : ""}>Casa</option>
                                    <option value="Piso" ${addressComp.tipo === "Piso" ? "selected" : ""}>Piso</option>
                                    <option value="Apartamento" ${addressComp.tipo === "Apartamento" ? "selected" : ""}>Apartamento</option>
                                </select>
                                <div class="row mt-4" id="swal-comp-campos">
                                    ${camposComplemento(addressComp.tipo, addressComp)}
                                </div>
                            </div>
                            <div class="mb-4">
                                <label for="NameLabelUpdate" class="labelFount">Email</label>
                                <input type="text" id="swal-input4" class="form-control" disabled placeholder="Email" value="${tableMeta.email_owner}">
                            </div>
                            <div class="mb-4">
                            <label for="NameLabelUpdate" class="labelFount">Tipo Solicitud</label>
                                <select class="select" id="tipoSol" style="width: 100%; height: 2rem; margin-bottom: 1.5rem;" ${isUser? "disabled" : ""}>
                                   <option key="" value="${getTipoClienteId(tableMeta.type_service)}">${tableMeta.type_service}</option>
                                    ${tipoCliente.map(opcion => `<option key="${opcion.id}" value="${opcion.id}" name="${opcion.name}">${opcion.name}</option>`).join('')}
                                </select>
                                <label for="NameLabelUpdate" class="labelFount">Estrato</label>
                                <select class="select" id="mySelectElement" style="width: 100%; height: 2rem; margin-bottom: 1.5rem;" ${isUser? "disabled" : ""}>
                                    <option value="${tableMeta.estrato}">${tableMeta.estrato}</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                </select>
                            </div>
                            <label for="NameLabelUpdate" class="labelFount">Adjuntar recibo publico</label>
                            ${campoArchivo("swal-input5", tableMeta.rec_pub)}
                            <label for="NameLabelUpdate" class="labelFount">Adjuntar cedula (cara frontal)</label>
                            ${campoArchivo("swal-input6", tableMeta.ad_cc)}
                            <label for="NameLabelUpdate" class="labelFount">Adjuntar cedula (cara posterior)</label>
                            ${campoArchivo("swal-input_back", tableMeta.ad_cc_back)}
                            <div class="mb-4">
                                <label for="NameLabelUpdate" class="labelFount">Plan</label>
                                <select class="select" id="planSelect" style="width: 100%; height: 2rem; margin-bottom: 1.5rem;" ${isUser? "disabled" : ""}>
                                    <option key="" value="">${tableMeta.plan}</option>
                                    ${planes.map(opcion => `<option key="${opcion.id__planes}" value="${opcion.id__planes},${opcion.nombre_plan},${encodeURIComponent(JSON.stringify(opcion))}">${opcion.nombre_plan}</option>`).join('')}
                                </select>
                                <label for="NameLabelUpdate" class="labelFount">Precio</label>
                                <input type="text" id="swal-price-input" disabled class="form-control" placeholder="Precio" value="${price_plan}">
                                <input type="text" id="swal-Plan-input" disabled class="form-control" style="display:none" value="${plan}">
                                <input type="text" id="swal-idplan-input" disabled class="form-control" style="display:none" value="${id_plan}">
                                <input type="text" id="swal-idopen-input" disabled class="form-control" style="display:none" value="${id_plan_open}">
                                <input type="text" id="swal-typeplan-input" disabled class="form-control" style="display:none" value="${plan_type}">
                            </div>
                            <div class="col-12">
                                <label for="NameLabelUpdate" class="labelFount">Contrato</label>
                                <input type="number" id="swal-input8" disabled class="form-control" placeholder="Contrato" value="${tableMeta.contract}">
                            </div>
                            <div class="row mb-4">
                                <label for="NameLabelUpdate" class="labelFount">Observaciones</label>
                                <textarea id="swal-input7" class="form-control" rows="5" placeholder="Para hacer saltos de linea presionar ENTER">${tableMeta.observations}</textarea>
                            </div>
                        </div>
                    </form>
                `,
                focusConfirm: false,
                confirmButtonText: "Editar",
                didOpen: () => {
                    ["swal-input5", "swal-input6", "swal-input_back"].forEach(id => {
                        const input = document.getElementById(id);
                        const nombre = document.getElementById(`${id}-nombre`);
                        document.getElementById(`${id}-cargar`).addEventListener("click", () => input.click());
                        input.addEventListener("change", () => { if (input.files[0]) nombre.textContent = input.files[0].name; });
                    });
                    const planSelect = document.getElementById('planSelect');
                    const estratoSelect = document.getElementById('mySelectElement');

                    const updatePriceOnSelectChange = () => {
                        const selectedPlan = planSelect.value.split(',');
                        const selectedEstrato = estratoSelect.value;
                        updatePrice(selectedPlan[2], selectedEstrato);
                    };

                    planSelect.addEventListener('change', updatePriceOnSelectChange);
                    estratoSelect.addEventListener('change', updatePriceOnSelectChange);

                    const compTipo = document.getElementById('swal-comp-tipo');
                    const compCampos = document.getElementById('swal-comp-campos');

                    compTipo.addEventListener('change', () => {
                        compCampos.innerHTML = camposComplemento(compTipo.value);
                    });
                },
                preConfirm: () => {
                    const headers = new Headers({ "Authorization": `Bearer ${token}` });

                    const comp = leerComplemento();

                    if (!complementoCompleto(comp)) {
                        Swal.showValidationMessage(
                            comp.tipo === "Apartamento" ? "Selecciona el piso y el No. apto"
                                : comp.tipo === "Casa" ? "Selecciona al menos la letra o el número de la casa"
                                    : "Selecciona el No. piso"
                        );
                        return false;
                    }

                    const addressFinal = [
                        document.getElementById("swal-address-base").value,
                        armarComplemento(comp),
                    ].filter(Boolean).join(" ");

                    var formdata = new FormData();
                    formdata.append("address", addressFinal);
                    formdata.append("name", document.getElementById("swal-name-input").value);
                    formdata.append("last_name", document.getElementById("swal-last_name-input").value);
                    formdata.append("cc", document.getElementById("swal-input2").value);
                    formdata.append("contact_phone", document.getElementById("swal-input3").value);
                    formdata.append("ad_cc", document.getElementById("swal-input6").files[0]);
                    formdata.append("ad_cc_back", document.getElementById("swal-input_back").files[0]);
                    formdata.append("rec_pub", document.getElementById("swal-input5").files[0]);
                    formdata.append("contract", document.getElementById("swal-input8").value);
                    formdata.append("observations", document.getElementById("swal-input7").value);
                    formdata.append("estrato", document.getElementById("mySelectElement").value);
                    formdata.append("id_plan", document.getElementById('swal-idplan-input').value);
                    formdata.append("id_plan_open", document.getElementById('swal-idopen-input').value);
                    formdata.append("plan_type", document.getElementById('swal-typeplan-input').value);
                    formdata.append("plan", document.getElementById('swal-Plan-input').value);
                    formdata.append("price_plan", document.getElementById('swal-price-input').value);
                    formdata.append("type_service", document.getElementById('tipoSol').value);

                    const categoryText = document.getElementById('tipoSol').options[document.getElementById('tipoSol').selectedIndex].text;
                     
                    formdata.append("category", categoryText);

                    const requestOptions = {
                        method: "PUT",
                        headers,
                        body: formdata,
                        redirect: "follow",
                    };

                    return fetch(`${domain}/portal/${tableMeta.id}/`, requestOptions)
                        .then(response => response.text())
                        .then(result => {
                            console.log(result);
                            Swal.fire("Guardado", "Se ha guardado con exito.", "success").then(() => window.location.reload());
                        })
                        .catch(error => console.log("error", error));
                },
            }))
            .catch(error => console.log("error", error));
    };

    return (
        <>
            {!allowedStatus.has(tableMeta.is_actived) && (

                <button
                    className='p-1 cursor-pointer bg-blue-600 hover:bg-blue-700 text-white rounded-md '
                    onClick={handleSubmit}
                    title="Editar"
                >
                    <EditPencil />
                </button>
            )}
        </>
    );
};